import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { selectInfo } from '../../account-info-header/reducers';
import {
  NicknameRequest,
  NicknameResponse
} from '../../shared/models/Nickname';
import { StatusViewService } from '../../shared/services/status-view.service';
import { MediaTypeCd } from '../../shared/types/Transaction';
import { StandingAuthorizationsTableActions } from '../actions';
import { ServiceError } from '../models/shared/ServiceError';
import { concatLatestFrom } from "@ngrx/operators";

@Injectable()
export class StandingAuthorizationsNicknameEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private statusViewService: StatusViewService
  ) { }

  addUpDateDeleteSloa$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StandingAuthorizationsTableActions.addUpdateDeleteNickname),
      concatLatestFrom(() => [this.store.select(selectInfo)]),
      switchMap(([action, info]) => {
        let requestType: string = action.requestType;
        let requestData: NicknameRequest = {
          nicknameRecord: {
            nickname: action.rowData.nickname,
            cashieringRequestId: action.rowData.standingAuthId.split('-')[1],
            cashieringSecRequestId: action.rowData.standingAuthId.split('-')[2],
            subAccountId: info.accountId,
            masterAccountId: info.masterAccount,
            type: getMediaCdFromTransactionType(action.rowData.transactionType),
          },
        };
        return this.statusViewService
          .addEditNickname(requestData, requestType)
          .pipe(
            map((response: NicknameResponse) => {
              return StandingAuthorizationsTableActions.addUpdateDeleteNicknameSuccess(
                requestData
              );
            }),
            catchError((err: ServiceError) => {
              return of(
                StandingAuthorizationsTableActions.addUpdateDeleteNicknameFailure(
                  err
                )
              );
            })
          );
      })
    )
  );
}

function getMediaCdFromTransactionType(transactionType: string): MediaTypeCd | '' {
  if (transactionType.includes('ACH')) {
    return 'A';
  }
  else if (transactionType.includes('Internal transfer')) {
    return 'J';
  }
  else if (transactionType.includes('Check')) {
    return 'C';
  }
  else if (transactionType.includes('Wire')) {
    return 'W';
  }
  else return '';
}
